import { ITenantBooleanSettings } from "@sp-crm/core";
import * as React from "react";
import { useTenantSettings } from "store/selectors/settings";

interface SettingProps {
    name: keyof ITenantBooleanSettings;
    children?: React.ReactNode;
}

export const Setting: React.FC<SettingProps> = props => {
    const { name, children } = props;
    const { settings } = useTenantSettings();

    const enabled = settings[name];

    if (enabled && children) {
        return children;
    }
    return null;
};
